import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getV1PagesUserList,
  postV1PagesShare,
} from "../../../api-client/api.system-feature/api";
import { getToken } from '../../../utils/common';

export const getAllUserAndDepartmentDropdown = createAsyncThunk(
  "share/getUser",
  async () => {
    const response = await getV1PagesUserList({ ...getToken() });
    return response;
  },
);

export const sharePage = createAsyncThunk(
  "share/sharePage",
  async (data: any) => {
    const response = await postV1PagesShare({ ...getToken(), data });
    return response;
  },
);
